import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
    loaderWrapper: {
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      alignContent: 'center',
      width: '100vw',
      height: '100vh',
      zIndex: '99999',
      top : 0,
      left : 0,
      background : "white"
}}))